var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnpinA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4945",
    d: "M8.54975 12.874L12.0027 16.327C12.0027 16.327 11.2399 13.6368 14.6129 10.2638C17.9858 6.89085 18.916 6.81391 18.916 6.81391L16.7668 4.65686",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 302",
    d: "M8.66357 4.57507L16.4417 12.3532",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4946",
    d: "M8.54924 12.8745L5.09625 9.42147C5.09625 9.42147 7.78644 10.1843 11.1594 6.81132C14.5323 3.43837 14.6773 2.5673 14.6773 2.5673L16.7666 4.65709",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 45",
    d: "M8.55005 12.8748L4.09293 17.3319",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 303",
    d: "M11.1387 4.92859L16.7955 10.5854",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 304",
    d: "M9.01733 7.04993L14.6742 12.7068",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnpinA);
export default __webpack_public_path__ + "static/media/Icon_unpin_a.f727633ca0616766bca2f51dce4f9ee2.svg";
export { ForwardRef as ReactComponent };